export class CaptchaValidationModel {
  CaptchaKey: string;
  UserCaptchaCode: string;
}
